import { Calculator } from "@/components/site/Calculator";
import { Seo } from "@/components/site/Seo";

export default function Preventivo() {
  return (
    <div className="mx-auto max-w-7xl px-4 lg:px-8 py-14 grid gap-12 lg:grid-cols-[0.9fr_1.1fr] items-start" data-testid="preventivo-page">
      <Seo title="Preventivo assicurazione cane e gatto in 30 secondi | Polizzapet.it" description="Quanto costa assicurare il tuo cane o gatto? Razza, età e città: scopri subito rischio sanitario, costi veterinari e una stima onesta del prezzo mensile, senza lasciare dati." />
      <div className="lg:sticky lg:top-24">
        <p className="label-mono text-emerald-500 mb-3">Preventivo in 30 secondi</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05]">Quanto costa assicurare il tuo pet? Scoprilo subito.</h1>
        <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed max-w-lg">Quattro domande, nessun dato personale. Ti diamo una stima onesta dei costi veterinari nella tua città e ti diciamo quale polizza ha più senso.</p>
        <ul className="mt-8 space-y-3 text-sm">
          {["Rischio sanitario per razza ed età", "Costi veterinari reali della tua città", "Stima del premio per 5 compagnie", "Se non ti serve una polizza, te lo diciamo"].map((t) => <li key={t} className="flex gap-2"><span className="text-emerald-500">✓</span>{t}</li>)}
        </ul>
      </div>
      <Calculator />
    </div>
  );
}
